import { render } from "./TopBar.vue?vue&type=template&id=573f3538&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=573f3538&scoped=true&lang=css"

import exportComponent from "/Users/jipfens/Library/Mobile Documents/com~apple~CloudDocs/iProjects/lexis/lexis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573f3538"]])

export default __exports__